var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._v(" container "),_vm._l((_vm.item.children),function(child,index){return [_c(("m-pages-" + (child.component) + "2"),{key:index,tag:"component",attrs:{"item":child}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }